import { RootState } from "@/store/store";
import { GetUsersMeOrganisationsCurrentWidgetsNormalizedCostApiArg } from "@/services/cloudchipr.api";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";

export const normalizedCostWidgetSetupDataPayloadSelector = (
  state: RootState,
): GetUsersMeOrganisationsCurrentWidgetsNormalizedCostApiArg | undefined => {
  const setup = normalizedCostWidgetSetupSelector(state);
  if (!setup) {
    return;
  }
  const { viewId, forecastOption, dates, visualization, trendType } = setup;

  return {
    viewId: viewId ?? "",
    dateLabel: dates?.label ?? undefined,
    dateFrom: dates?.from ?? undefined,
    dateTo: dates?.to ?? undefined,
    dateType: dates?.type ?? undefined,
    dateValue: dates?.value ?? undefined,
    dateUnit: dates?.unit ?? undefined,
    forecastOption,
    trendType,
    chartType: visualization.chart_type,
  };
};
